import Highlight from "./Highlight";
import RoyalOrbit from "./RoyalOrbit";
import SpiralPath from "./SpiralPath";
import SlotMachine from "./SlotMachine";
import FlipCards from "./FlipCards";
import RoyalWinner from "./RoyalWinner";
import CoinCrash from "./CoinCrash";
import NeonPortal from "./NeonPortal";

/**
 * Slug -> the show it plays. The slugs match
 * server/constants/winnerAnimations.js, which is what a game stores and
 * what the Settings dropdown offers; anything unrecognised falls back to
 * the plain default box rather than leaving a round with nothing.
 */
export const REVEAL_ANIMATIONS = {
  highlight: { component: Highlight, title: "Winner Draw", status: "The board is drawing" },
  royal_orbit: { component: RoyalOrbit, title: "Royal Orbit", status: "The ring is turning" },
  spiral_path: { component: SpiralPath, title: "Spiral Draw", status: "Into the centre" },
  slot_machine: { component: SlotMachine, title: "Lucky Reels", status: "The reels are running" },
  flip_cards: { component: FlipCards, title: "Card Reveal", status: "Cards are shuffling" },
  royal_winner: { component: RoyalWinner, title: "Royal Winner", status: "The throne is waiting" },
  coin_crash: { component: CoinCrash, title: "Coin Crash", status: "The coin is hunting" },
  neon_portal: { component: NeonPortal, title: "Neon Energy Portal", status: "The core is charging" },
};

/**
 * "default" is not a show: it is the plain "Winner processing" box the
 * closing seconds always had (WinnerReveal renders it itself). It is what
 * a game plays until it is given one of the shows above, and what any
 * unrecognised slug falls back to.
 */
export const DEFAULT_REVEAL_ANIMATION = "default";

const CLASSIC = { classic: true, title: "Winner processing" };

export const revealAnimationFor = (slug) =>
  REVEAL_ANIMATIONS[String(slug || "").trim()] || CLASSIC;
